import { createFileRoute } from "@tanstack/react-router"

import { HOME_SEO } from "@/brand/components/home/home-content"
import { HomePage } from "@/brand/components/home/home-page"
import { buildHead } from "@/core/seo"

export const Route = createFileRoute("/_brand-layout/")({
  head: () => {
    const { meta, links, scripts } = buildHead({ ...HOME_SEO, path: "/" })
    return { meta, links, scripts }
  },
  component: HomePage,
})
